const typeValues = {
    Short: "Short",
};

export { typeValues }
